import { css } from '@/styled-system/css';

export const filterChipIconStyles = css.raw({
  color: 'icon.neutral',
  marginInlineEnd: 'tighter',
});
